import { Component, Input } from '@angular/core';
import { Chart, registerables } from 'chart.js';

@Component({
  selector: 'chart-donut',
  standalone: true,
  imports: [],
  templateUrl: './donut.component.html',
  styleUrl: './donut.component.scss'
})
export class DonutComponent {
  chart: any = [];
  @Input() corrects: number = 0;
  @Input() wrongs: number = 0;

  constructor(){}

  ngOnInit() {
    Chart.register(...registerables);
    this.chart = new Chart('canvas', {
      type: 'doughnut',
      data: {
        labels: ['Acertos', 'Erros'],
        datasets: [
          {
            label: '# of Votes',
            data: [this.corrects, this.wrongs],
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }
}
